<!-- MODAL HEADER-->
<div class="row modal-bar">
  <div class="col-sm-6">
    <h5 class="modal-title">{{ passedData.title }}</h5>
  </div>
  <div class="col-sm-6">
    <div class="modal-actions">
      <div class="modal-close">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dialogRef.close(false);"></button>
      </div>
    </div>
  </div>
</div>


<div class="section-wrapper mt-5">

  <div class="form-layout">
    <div class="row">

      <div class="col-lg-12 mg-b-25">

        <t4-list-view #listVw [options]="listOptions" (onDataRequest)="onDataRequest($event)">

          <ng-container *t4ListItem="let item">

            <td>{{ item.OrderId }}</td>
            <td>{{ displayDescription(item.EventStartDateTime, item.EventName, item.PassePartoutName, item.MembershipName) | replaceOnEmpty }}</td>
            <td>{{ item.TicketTypeName }}</td>
            <td>{{ item.ParentSectionName }}</td>
            @if (item.ProductType == 1) {
              <td>{{ item.RowNumber | replaceOnEmpty}} / {{item.SeatNumber | replaceOnEmpty}}</td>
            }
            @if (item.ProductType != 1) {
              <td>-</td>
            }
            <td>{{ item.TicketCustomer }}</td>
            <td class="grid-cell">{{ item.PriceVariationName }}</td>
            <td class="text-end">{{ item.AmountExVat | localCurrency }}</td>
            <td class="text-end">{{ item.CalculatedDiscount | percent:'1.0-2' | replaceOnEmpty:'-' }}</td>
            <td class="text-end">{{ item.VAT | localCurrency }}</td>
            <td class="text-end">{{ item.AmountInclVat | localCurrency }}</td>

          </ng-container>

        </t4-list-view>
      </div>
    </div>
  </div><!-- form-layout -->
</div>
